import React from 'react';
import { NavLink } from 'react-router-dom';
import { NAV } from '@/constants/testIds';
import { useDashboard } from '@/context/DashboardContext';
import {
  LayoutGrid, GitFork, Users, ReceiptText, Map, Sparkles, BookOpen, Clock, ChevronLeft, ChevronRight
} from 'lucide-react';

const links = [
  { to: '/',           id: NAV.overview,  label: 'Overview',              icon: LayoutGrid },
  { to: '/pipeline',   id: NAV.pipeline,  label: 'Fundraising Pipeline',  icon: GitFork },
  { to: '/donors',     id: NAV.donors,    label: 'Donors',                icon: Users },
  { to: '/grants',     id: NAV.grants,    label: 'Grants & Utilisation',  icon: ReceiptText },
  { to: '/resources',  id: NAV.resources, label: 'Resource Utilisation',  icon: Clock },
  { to: '/geography',  id: NAV.geography, label: 'Geography',             icon: Map },
  { to: '/impact',     id: NAV.impact,    label: 'Beneficiaries & Impact',icon: Sparkles },
  { to: '/stories',    id: NAV.stories,   label: 'Stories of Change',     icon: BookOpen },
];

export default function Sidebar() {
  const { collapsed, setCollapsed } = useDashboard();

  return (
    <aside className={`sidebar ${collapsed ? 'collapsed' : ''}`}>
      <div className="side-label">Dashboard</div>
      {links.map(({ to, id, label, icon: Icon }) => (
        <NavLink
          key={id}
          to={to}
          end={to === '/'}
          data-testid={id}
          className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
          title={label}
        >
          <Icon size={17} strokeWidth={2} />
          <span className="nav-label">{label}</span>
        </NavLink>
      ))}

      <button
        type="button"
        className="nav-item"
        data-testid={NAV.collapse}
        onClick={() => setCollapsed(!collapsed)}
        title={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        style={{ marginTop: 10, color: 'var(--gray-500)' }}
      >
        {collapsed ? <ChevronRight size={15} strokeWidth={2} /> : <ChevronLeft size={15} strokeWidth={2} />}
        <span className="nav-label">Collapse</span>
      </button>

      <div className="side-foot">
        Grantee dashboard for <b>Sahaya Foundation</b>. All donor pipeline, allocations
        and financial figures are illustrative <b>mock data</b>; impact anchored to
        Smile Foundation Annual Report 2023-24 (public domain).
      </div>
    </aside>
  );
}
